import React from "react";
import Layout from "../components/Layout";
import ContactForm from "../components/contactForm";

function VirtualParties(ctx) {
  const pageDescription =
    "Hosted Virtual Race Nights for your office parties.  Turn you remote party into an action packed race night.";
  const pageTitle = "Hosted Virtual Race Nights for your office party!";

  return (
    <Layout
      canonical="https://www.track-night.com/virtual-office-parties"
      brand={ctx.brand}
      showHeaderLinks={true}
      ogDescription={pageDescription}
      ogTitle={pageTitle}
    >
      <div className="container">
        <div className="section">
          <h1 className="title">
            Virtual Office Parties and Remote Team Building Events
          </h1>
          <div className="columns">
            <div className="column">
              <p>Host your own virtual horse racing night.</p>
              <p>
                Get your team together, get some prizes sorted, and get started
                with a fast paced night of racing.
              </p>
              <p>
                Get in touch and let us know your requirements and we can talk
                through what we can do for you!
              </p>
            </div>
            <div className="column is-5">
              <img src="/remote-horse-racing.jpg" alt="virtual office party" />
            </div>
          </div>
          <br />
          <br />
          <ContactForm subject="virtual office parties" />
        </div>
      </div>
    </Layout>
  );
}

export default VirtualParties;
